import React from 'react';
import cn from 'clsx';

import styles from './ListItem.module.css';

type ListItemtagName = 'div' | 'li' | 'p';

export interface IListItemProps {
  className?: string;
  as?: ListItemtagName;
  icon: React.ReactNode;
  label: string;
  'data-testid'?: string;
}

export const ListItem = ({ className, label, icon, as: Tag = 'li', 'data-testid': dataTestId }: IListItemProps) => {
  return (
    <Tag data-testid={dataTestId} className={cn(styles.listItem, className)}>
      <span className={styles.icon} aria-hidden="true" role="presentation">
        {icon}
      </span>
      {label}
    </Tag>
  );
};
